// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-popper{padding:10px 0}.menu-popper .sub-menu-title i{padding-left:24px}", ""]);
// Exports
module.exports = exports;
